module.exports = __webpack_public_path__ + "static/media/gift4.e6f9f80f.png";